<img *ngIf="etaType == ETA_TYPE.AUTOMATIC" src="./assets/icon-location.svg">
<img *ngIf="etaType == ETA_TYPE.DYNAMIC" src="./assets/icon-chep.svg">
<img *ngIf="etaType == ETA_TYPE.SAP" src="./assets/icon-sap.svg">
<img *ngIf="etaType == ETA_TYPE.BLUEYONDER" class="by-img" src="./assets/icon-by.svg">
<img *ngIf="etaType == ETA_TYPE.CARRIER" class="by-img" src="./assets/icon-by.svg">
<img *ngIf="etaType == ETA_TYPE.FOURKITES" src="./assets/icon-fourkites.svg">
